import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const credentials = [
    'Illinois Commissioned Mobile Notary Public and Loan Signing Agent',
    'Loan Signing System Certified',
    'NNA Certified & Background Screened',
    'Bonded & Insured',
    'Serving Northern Illinois',
  ];

  return (
    <footer className="bg-beige text-black">
      <div className="max-w-7xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <img
              src="https://static.readdy.ai/image/bab879b74deccfeed2a00a2e2fd79f12/2182d924ce0d4a01909e3f4cd93a7992.png"
              alt="JSJ Burton Enterprises, LLC DBA A Burton Notary"
              className="h-20 w-auto mb-4"
            />
            <h3 className="text-lg font-heading font-bold mb-2 text-gold">
              JSJ Burton Enterprises, LLC
            </h3>
            <p className="text-sm font-body text-navy font-semibold mb-2">
              DBA A Burton Notary
            </p>
            <p className="text-sm text-gray-600 font-body leading-relaxed mb-3">
              Illinois Commissioned Mobile Notary Public and Loan Signing Agent
            </p>
            <div className="text-sm text-gray-600 font-body mb-3">
              <a 
                href="https://maps.google.com/?q=201+B+Canterbury+Ln,+Bolingbrook,+IL+60440" 
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-start gap-2 hover:text-gold transition-colors cursor-pointer"
              >
                <i className="ri-map-pin-line text-teal mt-0.5 flex-shrink-0"></i>
                <span>201 B Canterbury Ln, Bolingbrook, IL 60440</span>
              </a>
            </div>
            <div className="text-sm text-gray-600 font-body">
              <p className="font-semibold text-navy mb-1">Business Hours:</p>
              <p>8:00 AM - 5:00 PM</p>
              <p className="text-xs mt-1">After-hours available upon request</p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-base font-heading font-semibold mb-4 text-navy">
              Quick Links
            </h4>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-sm font-body text-gray-600 hover:text-gold transition-colors"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/services"
                  className="text-sm font-body text-gray-600 hover:text-gold transition-colors"
                >
                  Services
                </Link>
              </li>
              <li>
                <Link
                  to="/partnerships"
                  className="text-sm font-body text-gray-600 hover:text-gold transition-colors"
                >
                  Partnerships
                </Link>
              </li>
              <li>
                <Link
                  to="/service-area"
                  className="text-sm font-body text-gray-600 hover:text-gold transition-colors"
                >
                  Service Area
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-sm font-body text-gray-600 hover:text-gold transition-colors"
                >
                  About
                </Link>
              </li>
              <li>
                <Link
                  to="/fees"
                  className="text-sm font-body text-gray-600 hover:text-gold transition-colors"
                >
                  Fees
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-sm font-body text-gray-600 hover:text-gold transition-colors"
                >
                  Contact
                </Link>
              </li>
              <li>
                <Link
                  to="/qr-code"
                  className="text-sm font-body text-gray-600 hover:text-gold transition-colors"
                >
                  QR Code
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-base font-heading font-semibold mb-4 text-navy">
              Services
            </h4>
            <ul className="space-y-2">
              <li className="text-sm font-body text-gray-600">Loan Signing Services</li>
              <li className="text-sm font-body text-gray-600">Mobile Notary Services</li>
              <li className="text-sm font-body text-gray-600">Business Support</li>
              <li className="text-sm font-body text-gray-600">After-Hours Signings</li>
            </ul>
          </div>

          {/* Credentials */}
          <div>
            <h4 className="text-base font-heading font-semibold mb-4 text-navy">
              Credentials
            </h4>
            <ul className="space-y-2">
              {credentials.map((credential, index) => (
                <li key={index} className="flex items-start gap-2">
                  <i className="ri-check-line text-teal text-sm mt-0.5 flex-shrink-0"></i>
                  <span className="text-sm font-body text-gray-600">{credential}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-gray-300">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm font-body text-gray-500">
              JSJ Burton Enterprises, LLC DBA A Burton Notary © {currentYear} All Rights Reserved
            </p>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm font-body text-gray-500 hover:text-gold transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
